/**
 *
 * Asynchronously loads the component for Reports
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Reports/Loadable.js